"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Content = /*#__PURE__*/function (_React$Component) {
  _inherits(Content, _React$Component);
  var _super = _createSuper(Content);
  function Content(props) {
    var _this;
    _classCallCheck(this, Content);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "setVideoWidth", function () {
      var _this$state = _this.state,
        videoWidth = _this$state.videoWidth,
        videoHeight = _this$state.videoHeight;
      if (_this.videoRef.current) {
        var width = _this.videoRef.current.getBoundingClientRect().width;
        _this.videoRef.current.style.height = "".concat(width * (videoHeight / videoWidth), "px");
      }
    });
    _defineProperty(_assertThisInitialized(_this), "renderText", function () {
      // infoBarTextColor for backwards compatibility only - should use wysiwyg instead
      var _this$props = _this.props,
        displayOptions = _this$props.displayOptions,
        text = _this$props.text;
      var styles = displayOptions && displayOptions.portal && displayOptions.portal.infoBarTextColor ? {
        color: displayOptions.portal.infoBarTextColor
      } : {};
      return !!text && /*#__PURE__*/_react["default"].createElement("span", {
        style: styles
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: text
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderImage", function () {
      return !_this.props.config.backgroundImage && /*#__PURE__*/_react["default"].createElement("img", {
        className: _style["default"].image,
        src: _this.props.image.url,
        alt: "banner"
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderVideo", function () {
      return !!_this.props.video && /*#__PURE__*/_react["default"].createElement("div", {
        ref: _this.videoRef,
        className: _style["default"].videoRef
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: _this.props.video
      }));
    });
    var _videoWidth;
    var _videoHeight;
    try {
      _videoWidth = Number(props.video.match(/width=["']{1}[0-9]{1,4}["']{1}?/)[0].replace(/[^\d]/g, ''));
      _videoHeight = Number(props.video.match(/height=["']{1}[0-9]{1,4}["']{1}?/)[0].replace(/[^\d]/g, ''));
    } catch (e) {
      if (props.video) {
        console.error('Cannot determine width and height on video <iframe>; Assuming 16:9 aspect ratio.');
        _videoWidth = 16;
        _videoHeight = 9;
      }
    }
    _this.state = {
      videoWidth: _videoWidth,
      videoHeight: _videoHeight
    };
    _this.videoRef = /*#__PURE__*/_react["default"].createRef();
    _this.divRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  _createClass(Content, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.video && ['videoText', 'textVideo'].includes(this.props.layout)) {
        this.setVideoWidth();
        window.addEventListener('resize', this.setVideoWidth);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.video && ['videoText', 'textVideo'].includes(this.props.layout)) {
        window.removeEventListener('resize', this.setVideoWidth);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        image = _this$props2.image,
        config = _this$props2.config,
        layout = _this$props2.layout;
      var leftSide;
      var rightSide;
      switch (layout) {
        case 'textImage':
          leftSide = this.renderText();
          rightSide = this.renderImage();
          break;
        case 'imageText':
          leftSide = this.renderImage();
          rightSide = this.renderText();
          break;
        case 'textVideo':
          leftSide = this.renderText();
          rightSide = this.renderVideo();
          break;
        case 'videoText':
          leftSide = this.renderVideo();
          rightSide = this.renderText();
          break;
        default:
          leftSide = this.renderText();
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].content,
        style: config && config.backgroundImage && (layout === 'textImage' || layout === 'imageText') ? {
          backgroundImage: "url(".concat(image.url, ")"),
          backgroundSize: 'cover',
          backgroundPosition: 'center center'
        } : {},
        ref: this.divRef
      }, leftSide && /*#__PURE__*/_react["default"].createElement("div", null, leftSide), rightSide && /*#__PURE__*/_react["default"].createElement("div", null, rightSide));
    }
  }]);
  return Content;
}(_react["default"].Component);
exports["default"] = Content;
_defineProperty(Content, "propTypes", {
  config: _propTypes["default"].object,
  displayOptions: _propTypes["default"].object,
  image: _propTypes["default"].object,
  layout: _propTypes["default"].string,
  text: _propTypes["default"].string,
  video: _propTypes["default"].string
});